
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M11.293 26.707l-5.00003-5c-.39063-.3906-.39063-1.0234 0-1.414.39062-.3906 1.02344-.3906 1.41406 0L11 23.5859V14c0-.5527.4473-1 1-1 .5528 0 1 .4473 1 1v9.5859l3.293-3.2929c.3906-.3906 1.0234-.3906 1.414 0 .3907.3906.3907 1.0234 0 1.414l-5 5c-.1953.1954-.4511.293-.707.293-.2558 0-.5117-.0976-.707-.293z"}}),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M17.8762.88125l5.2425 5.2425C23.6812 6.68625 24 7.455 24 8.24813V29.0006C24 30.6562 22.6562 32 21.0006 32H2.99938C1.34375 32 0 30.6562 0 29.0006V3.00563C0 1.35 1.34375.00625 2.99938 0H15.7581c.7932 0 1.5556.31875 2.1181.88125zm-1.4118 1.41813c-.1313-.13125-.2875-.21875-.4625-.2625v5.9675h5.9675c-.0438-.175-.1313-.33126-.2625-.46251l-5.2425-5.24249zM2.99938 30.0006H21.0006c.55 0 1-.45 1-1V10h-6.4987c-.8313 0-1.5-.66437-1.5-1.49562V2H2.99938c-.55 0-1.00001.45563-1.00001 1.00563V29.0006c0 .55.45001 1 1.00001 1z","clip-rule":"evenodd"}})])
          )
        }
      }
    